// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "promo-1WC6J";
var _4 = "promo__image-UosII";
export { _1 as "__esModule", _2 as "mobile", _3 as "promo", _4 as "promo__image" }
export default { "__esModule": _1, "mobile": _2, "promo": _3, "promo__image": _4 }
